import { toast } from "sonner";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { waLink, TIPOS_CITA } from "@/lib/api";

const hoy = () => format(new Date(), "yyyy-MM-dd");
const quien = (a) => a.patient?.nombre || a.titulo || TIPOS_CITA[a.tipo]?.label || "cita";
const dia = (f) => (f === hoy() ? "hoy" : `el ${format(new Date(`${f}T12:00`), "EEEE d 'de' MMMM", { locale: es })}`);

export const msgCitas = (p, citas, date) => {
  const lineas = citas.map((a) => `• ${a.inicio}–${a.fin} · ${a.patient?.nombre || a.titulo || ""}${a.patient?.codigo ? ` (nº ${a.patient.codigo})` : ""} · ${TIPOS_CITA[a.tipo]?.label || ""}${a.patient && a.titulo ? ` · ${a.titulo}` : ""}`);
  return `Hola ${p.nombre.split(" ")[0]}, tus citas del ${format(date, "EEEE d 'de' MMMM", { locale: es })}:\n${lineas.length ? lineas.join("\n") : "No tienes citas."}`;
};

const lanzar = (p, texto) => {
  if (!p) return;
  const nombre = p.nombre.split(" ")[0];
  if (!p.telefono) {
    toast.info(`Para avisar a ${nombre} por WhatsApp, pon su móvil en Equipo`, { duration: 8000 });
    return;
  }
  toast(`¿Avisar a ${nombre} del cambio de hoy?`, {
    duration: 15000,
    action: { label: "WhatsApp", onClick: () => window.open(waLink(p.telefono, `Hola ${nombre}, cambio en tu agenda: ${texto}`), "_blank") },
  });
};

export const avisarCambio = ({ profs, orig, nuevo, accion }) => {
  if (!orig || orig.tipo === "bloqueo") return;
  const hoyF = hoy();
  const pOrig = profs.find((x) => x.id === orig.profesional_id);
  const q = quien(orig);
  if (accion === "anulada" || accion === "borrada") {
    if (orig.fecha === hoyF) lanzar(pOrig, `se ha ${accion === "anulada" ? "anulado" : "quitado"} la cita de hoy a las ${orig.inicio} (${q}).`);
    return;
  }
  if (!nuevo || (nuevo.fecha === orig.fecha && nuevo.inicio === orig.inicio && nuevo.profesional_id === orig.profesional_id)) return;
  const pNuevo = profs.find((x) => x.id === nuevo.profesional_id);
  const mismo = nuevo.profesional_id === orig.profesional_id;
  if (orig.fecha === hoyF || (mismo && nuevo.fecha === hoyF)) {
    lanzar(pOrig, mismo ? `la cita de ${dia(orig.fecha)} a las ${orig.inicio} (${q}) pasa a ${dia(nuevo.fecha)} a las ${nuevo.inicio}.` : `la cita de hoy a las ${orig.inicio} (${q}) pasa a ${pNuevo?.nombre || "otra profesional"}.`);
  }
  if (!mismo && nuevo.fecha === hoyF) lanzar(pNuevo, `tienes una cita nueva hoy a las ${nuevo.inicio} (${q}).`);
};
